/*
 * Decodificador de referencias Zebra — projit.es
 *
 * Traduce la referencia (SKU) de una impresora Zebra a modelo comercial,
 * ancho y resolución, y busca esa referencia en el catálogo de la tienda.
 *
 * La tabla de modelos la genera `generar_tabla_zebra.py` desde el catálogo
 * (`tabla-zebra.js`, cargado antes que este fichero). Aquí no hay ningún
 * dato escrito a mano.
 */
(function () {
  'use strict';

  var $ = function (id) { return document.getElementById(id); };
  var els = {
    input: $('dz-input'),
    boton: $('dz-boton'),
    ejemplos: $('dz-ejemplos'),
    vacio: $('dz-vacio'),
    resultado: $('dz-resultado'),
    desglose: $('dz-desglose'),
    modelo: $('dz-modelo'),
    modeloEnlace: $('dz-modelo-enlace'),
    ancho: $('dz-ancho'),
    resolucion: $('dz-resolucion'),
    aviso: $('dz-aviso'),
    catalogo: $('dz-catalogo'),
    catalogoLista: $('dz-catalogo-lista')
  };

  if (!els.input) return;

  var TABLA = window.TABLA_ZEBRA || {};

  // Código de resolución -> dpi. Validado contra los dpi declarados en el
  // título de las 227 impresoras del catálogo que los declaran: 100%.
  var RESOLUCION = { '2': 203, '3': 300, '6': 600 };

  // Solo ZT, ZD y ZE. Las ZQ portátiles quedan fuera a propósito: ahí ese
  // dígito es la serie, no el ancho (ZQ52 es serie 5 modelo 2), y aplicarles
  // esta regla daba 14 anchos equivocados de 14 comprobables. Las ZC de
  // tarjetas tampoco: no hay ni un caso validable en el catálogo.
  var RE_CABEZA = /^(Z[TDE][A-Z0-9]*?)([1-9])([236])$/;
  var SERIES_FUERA = {
    ZQ: 'las impresoras portátiles ZQ',
    ZC: 'las impresoras de tarjetas ZC'
  };

  function limpiar(txt) {
    return (txt || '').toString().trim().toUpperCase().replace(/\s+/g, '');
  }

  function decodificar(sku) {
    var cabeza = sku.split('-')[0];
    var m = RE_CABEZA.exec(cabeza);
    if (!m) return null;
    return {
      cabeza: cabeza,
      codigoModelo: m[1],
      digitoAncho: m[2],
      digitoResolucion: m[3],
      ancho: parseInt(m[2], 10),
      dpi: RESOLUCION[m[3]]
    };
  }

  function pintarDesglose(d) {
    els.desglose.innerHTML = '';
    var partes = [
      { txt: d.codigoModelo, clase: 'dz-p-modelo', etiqueta: 'modelo' },
      { txt: d.digitoAncho, clase: 'dz-p-ancho', etiqueta: 'ancho' },
      { txt: d.digitoResolucion, clase: 'dz-p-res', etiqueta: 'resolución' }
    ];
    partes.forEach(function (p) {
      var span = document.createElement('span');
      span.className = 'dz-parte ' + p.clase;
      var chars = document.createElement('strong');
      chars.textContent = p.txt;
      var et = document.createElement('small');
      et.textContent = p.etiqueta;
      span.appendChild(chars);
      span.appendChild(et);
      els.desglose.appendChild(span);
    });
  }

  function mostrarAviso(html) {
    els.vacio.hidden = true;
    els.resultado.hidden = true;
    els.aviso.hidden = false;
    els.aviso.innerHTML = html;
  }

  function analizar() {
    var sku = limpiar(els.input.value);
    els.catalogo.hidden = true;

    if (!sku) {
      els.vacio.hidden = false;
      els.resultado.hidden = true;
      els.aviso.hidden = true;
      return;
    }

    var serie = sku.slice(0, 2);
    if (SERIES_FUERA[serie]) {
      mostrarAviso('En <strong>' + SERIES_FUERA[serie] + '</strong> la referencia ' +
        'no codifica el ancho ni la resolución de la misma forma, así que ' +
        'aquí no se deduce nada: preferimos no decir un dato antes que decir ' +
        'uno equivocado. Búscala en el ' +
        '<a href="/collections/impresoras-1">catálogo de impresoras</a> o ' +
        '<a href="/pages/contacto">pregúntanos</a>.');
      buscarEnCatalogo(sku);
      return;
    }

    var d = decodificar(sku);
    if (!d) {
      mostrarAviso('No se reconoce <strong>' + sku + '</strong> como referencia ' +
        'de impresora Zebra de las series ZT, ZD o ZE. Comprueba que esté ' +
        'completa; si es de otra marca o de otro tipo de equipo, ' +
        '<a href="/pages/contacto">escríbenos</a> y te decimos qué es.');
      buscarEnCatalogo(sku);
      return;
    }

    els.vacio.hidden = true;
    els.aviso.hidden = true;
    els.resultado.hidden = false;

    pintarDesglose(d);

    var info = TABLA[d.cabeza.slice(0, 6)];
    if (info) {
      els.modelo.textContent = info.modelo;
      if (info.handle) {
        els.modeloEnlace.hidden = false;
        els.modeloEnlace.href = '/collections/' + info.handle;
        els.modeloEnlace.textContent = 'Ver todas las referencias del ' + info.modelo;
      } else {
        els.modeloEnlace.hidden = true;
      }
    } else {
      els.modelo.textContent = 'No identificado';
      els.modeloEnlace.hidden = true;
    }

    var mm = Math.round(d.ancho * 25.4);
    els.ancho.textContent = d.ancho + '″ (unos ' + mm + ' mm)';
    els.resolucion.textContent = d.dpi + ' dpi';

    buscarEnCatalogo(sku);
  }

  // Búsqueda en el catálogo real de la tienda. Se usa la búsqueda predictiva
  // de Shopify, así que no hay ninguna lista de productos embebida aquí que
  // pueda quedarse vieja.
  function buscarEnCatalogo(sku) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(sku) +
      '&resources[type]=product&resources[limit]=5';
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var productos = (((d.resources || {}).results || {}).products) || [];
        if (!productos.length) {
          els.catalogo.hidden = true;
          return;
        }
        els.catalogoLista.innerHTML = '';
        productos.forEach(function (p) {
          // La búsqueda es aproximada: devuelve referencias parecidas. Se
          // marca cuál es la exacta leyendo el «SKU: …» del propio título,
          // que es el formato canónico del catálogo.
          var m = /SKU:\s*([A-Z0-9._\/-]+)/i.exec(p.title || '');
          var exacto = !!(m && m[1].toUpperCase() === sku);

          var li = document.createElement('li');
          li.className = 'dz-item' + (exacto ? ' es-exacto' : '');
          var a = document.createElement('a');
          a.href = (p.url || '').split('?')[0];
          a.textContent = p.title || '';
          li.appendChild(a);
          if (exacto) {
            var badge = document.createElement('span');
            badge.className = 'dz-badge';
            badge.textContent = 'Referencia exacta';
            li.insertBefore(badge, a);
          }
          els.catalogoLista.appendChild(li);
        });
        els.catalogo.hidden = false;
      })
      .catch(function () { els.catalogo.hidden = true; });
  }

  els.boton.addEventListener('click', analizar);
  els.input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); analizar(); }
  });
  els.ejemplos.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sku]');
    if (!b) return;
    els.input.value = b.getAttribute('data-sku');
    analizar();
  });
})();
